const getProductTypeFromQueryString = (query) => {
  const params = new URLSearchParams(query);
  const productType = params.get("productType");
  return productType ? productType.toLowerCase() : void 0;
};
export {
  getProductTypeFromQueryString
};
//# sourceMappingURL=get-product-type-from-query-string.js.map
